import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { OTROS, REQUERIMIENTO } from '../../../common/types/tipoComprobanteType';
import { SOLES,DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { LOGISTICA_REQUERIMIENTO } from '../../../common/types/referenciaOrigenType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import requerimientoService from '../../../service/logistica/requerimientoProduccionService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import vendedorService from '../../../service/administracion/vendedorService';
import entidadService from '../../../service/administracion/entidadService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import detraccionService from '../../../service/administracion/detraccionService';
import proyectoService from '../../../service/administracion/proyectoService';
import usuarioService from '../../../service/seguridad/usuarioService';
import centroCostoService from '../../../service/tesoreria/centroCostoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import FormModal from './FormModal';
import FormModalVer from './FormModalVer';
import ResultList from './ResultList';
import BuscarProductoModal from './BuscarProductoModal';
import ImportarRequerimientoModal from './ImportarRequerimientoModal';
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';
import auth from '../../../common/utility/auth';

var referenciaCount = 1;

export default class Index extends PaginationBase {

    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            centrocosto: [],
            almacenes: [],
            vendedores: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            detracciones: [],
            requerimientos: [],
            proyectos: [],
            entidades: [],
            estado:[],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstado:0,
                idEntidad:0,
                idTipoAntividad:0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleVer: false,
            productoVisible: false,
            importarRequerimientoVisible: false,
            renombrarProductoVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarRequerimientoModal: {
                nombre: '',
                dataSource: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            imprimirFormValues: {
                file: undefined,
                idRequerimiento: 0
            }
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: '',
            idEstado: 0,
            idEntidad: 0,
            idTipoAntividad: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    fetchMinCurrentDateStr(firstDayOfTheMonth) {
        var date = new Date();
        var yyyy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
        return yyyy + '/' + mm + '/' + dd;
    };

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            //idTipoComprobante: FACTURA.ID,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoEntidad: 0, //..........................................................OK
            idProyecto: 0,
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            serie: "RP01", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            minFechaStr: this.fetchMinCurrentDateStr(),
            diasVencimiento: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            entidadLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            listasPrecio: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            establecimientos: [],
            centrocosto: [],
            proyectos: [],
            entidades: [],
            idRequerimientoReferencia: 0,
            idCentrocosto:0,
        }
    };

    fetchEmptyFormResetValues = () => {
        return {
            id: 0,
            //idTipoComprobante: FACTURA.ID,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoEntidad: 0, //..........................................................OK
            idProyecto: 0,
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            serie: "RP01", //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            entidadLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            listasPrecio: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            establecimientos: [],
            centrocosto: [],
            proyectos: [],
            entidades: [],
            idRequerimientoReferencia: 0,
            idCentrocosto:0
        }
    };

    handleNew = async () => {
        var series_usuario = await usuarioService.listarSeriesPorIdUsuario(auth.user().id);
        var serie_req = series_usuario.filter(m=>m.idTipoComprobante == REQUERIMIENTO.ID).length > 0 ? series_usuario.filter(m=>m.idTipoComprobante == REQUERIMIENTO.ID)[0].serie : "";
        var formValues = this.fetchEmptyFormValues();
        formValues.entidades = this.state.entidades;
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos= this.state.establecimientos;
        formValues.centrocosto= this.state.centrocosto;

        var filterSearchReq = {
            idEstadoRequerimiento: 0,
            filtro: ''
        };
        var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);

        //debugger
        this.setState({
            visible: true,
            formValues,
            productos: [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            },
            requerimientos: requerimientos ? requerimientos : [],
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal
            }
        });
    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {

        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].compraSunat).toFixed(3);
        else
            return '0.000';
    }


    handleChangeForm = async (property, value, form) => {
        debugger
        if  (property === "idEntidad") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : []
                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoEntidad: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
                });
            });
        }

        if(property==="idCentrocosto"){

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idCentrocosto: value
                }
            });
        }

        if (property === "idEstablecimiento") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            //const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //almacenLoading: false,
                    //almacenes: almacenes ? almacenes : []
                }
            });
        }
        var arrayD1, arrayD2, date1, dateFV, Difference_In_Time, Difference_In_Days;
        if (property === "fechaStr") {
            arrayD1 = value.split('/');
            arrayD2 = this.state.formValues.fechaVencimientoStr.split('/');

            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

            Difference_In_Time = dateFV.getTime() - date1.getTime();
            Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    diasVencimiento: Difference_In_Days,
                    fechaStr: value,
                    minFechaStr: (arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]),
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario)
                }
            });
        }

        if (property === "fechaVencimientoStr") {
            debugger
            arrayD1 = this.state.formValues.fechaStr.split('/');
            arrayD2 = value.split('/');

            date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

            Difference_In_Time = dateFV.getTime() - date1.getTime(); 
            Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    diasVencimiento: Difference_In_Days,
                    fechaVencimientoStr: value
                }
            });
        }

        if (property === "diasVencimiento") {
            debugger
            arrayD1 = this.state.formValues.fechaStr.split('/');
            date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
            var fechaVencimiento = date1.setDate(date1.getDate() + parseInt(value));

            let day = date1.getDate()
            let month = date1.getMonth() + 1
            let year = date1.getFullYear()

            var fechaVencStr = '';

            if (month < 10) {
                fechaVencStr = `${day}/0${month}/${year}`;
            } else {
                fechaVencStr = `${day}/${month}/${year}`;
            }
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fechaVencimientoStr: fechaVencStr,
                    diasVencimiento: parseInt(value)
                }
            });
        }

    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = () => {
        if (this.state.formValues.activeKey === "1")
            this.handleBuscarProducto();

        if (this.state.formValues.activeKey === "2")
            this.handleAddReferencia();
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: referenciaCount,
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: false
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        debugger
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }

    handleBuscarProducto = async () => {
        //000001 BIENES // 000002 SERVICIO
        var productos = await productoService.listarPorRequeremiento(1);
        
        this.setState({
            productoVisible: true,
            productoModal: {
                ...this.state.productoModal,
                dataSource: productos,
                selectedRowKeys: []
            },
         
        });
    }

    handleImportarRequerimiento = () => {
        this.setState({
            importarRequerimientoVisible: true,
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: this.state.requerimientos
            }
        })
    }

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        //console.log(value);
        //var arrDetalle = this.props.form.getFieldValue("arrDetalle");
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === value.idProducto)[0];
            currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleChangeProductoModal = (value) => {
        const dataSource = this.state.productos.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            productoModal: {
                ...this.state.productoModal,
                dataSource: dataSource
            }
        });
    };

    handleChangeSelectedRowKey = (selected, rows) => {
        debugger
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if(rows.length > 1) {
            dialog.error('Solo se puede agregar un solo producto');
            return false;
        }
        rows.forEach(item => {
            var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
            if (filter.length === 0) {
                
                listaComprobanteDetalle.push({
                    idProducto: item.id,
                    nombre: item.nombre,
                    cantidad: 0,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida
                })
            }
        });

        listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selected
            }
        });
    };

    handleSelectedRowRequerimientoPorImportar = async (selected, rows) => {
        debugger

        if(selected.length > 1){
            dialog.error('Solo se puede agregar un solo registro');
            return false;

        }
        const idReqImport = selected[selected.length - 1];
        const response = await requerimientoService.obtenerPorId(idReqImport);
        var arraySelect = [];
        arraySelect.push(idReqImport);
        var formValues = this.fetchEmptyFormValues();


        this.setState({
            formValues
        });

        if (response !== undefined) {
            
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === SOLES);
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;

            const filterSearchEntidad = {
                numeroDocumento: formValues.documentoEntidad,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }
            const responseEntidades = await entidadService.obtenerTodos(filterSearchEntidad);
            const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(formValues.idEntidad);

            formValues.entidades = responseEntidades;
            formValues.direcciones = direccionesEstablecimientos;
            formValues.proyectos = this.state.proyectos;

            const products = [];
            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    //id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida
                }
                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            var itemRefReq = {
                identifier: 1,
                idReferencia: response.requerimiento.id,
                idReferenciaOrigen: LOGISTICA_REQUERIMIENTO,
                idTipoComprobante: REQUERIMIENTO.ID,
                serie: response.requerimiento.serie,
                documento: response.requerimiento.documento,
                flagInterno: true
            }
            formValues.listaComprobanteReferencia.push(itemRefReq);

            formValues.activeKey = "2";
            formValues.idRequerimientoReferencia = idReqImport;

            this.setState({
                visible: true,
                formValues,
                importarRequerimientoVisible: false,
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: products
                }
            });
            //this.handleChangeTab(2);
        }
    }

    handleRemoverProducto = (id) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== id);
        var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== id);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            },
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: selectedRowKeys
            }
        });
    };

    handleOnChangeEntidad = async (value) => {   
        console.log(value);
        const numeroDoc = value.label.split('-')[2];
        this.setState({
            formValues: {
                ...this.state.formValues,
                documentoEntidad: numeroDoc
            }
        });

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value.key);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //entidadLoading: false,
                    //entidades: [],
                    direcciones: [],
                    documentoEntidad: ''
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direccionesEstablecimientos
                }
            });
        }
    }

    handleBuscarEntidad = async (value) => {

        if (value.length > 2) {

            debugger
            this.setState({ formValues: { ...this.state.formValues, entidadLoading: true } });

            const filter = {
                numeroDocumento: value,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }

            //const response = await padronReducidoService.obtenerPorDocumentoTipoComprobante(filter);
            const response = await entidadService.obtenerTodos(filter);

            if (response === undefined) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        entidadLoading: false,
                        entidades: [],
                        direcciones: [],
                    }
                });
            }
            else {

                const resultFilter = response.filter(item => {
                    return (item.numeroDocumento + ' - ' + item.nombre)
                        .toUpperCase()
                        .match(value.toUpperCase());
                });

                //console.log(resultFilter)
                var direccionesEstablecimientos = [];
                if (resultFilter.length === 1) {
                    direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(resultFilter[0].id);
                }

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        entidadLoading: false,
                        entidades: resultFilter,//.entidades,
                        idEntidad: resultFilter.length === 1 ? resultFilter[0].id : 0,
                        direcciones: direccionesEstablecimientos,
                        idEstablecimientoEntidad: direccionesEstablecimientos.length === 1 ? direccionesEstablecimientos[0].id : 0
                    }
                });
            }

        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    entidadLoading: false,
                    entidades: [],
                    direcciones: [],
                }
            });
        }

    };

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger

            if (values.requerimientoDetalles !== undefined) {
                for (var i = 0; i < values.requerimientoDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === values.requerimientoDetalles[i].idProducto)[0];
                    values.requerimientoDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await requerimientoService.registrar(values);
            else
                response = await requerimientoService.modificar(values);
            
            if (response.status === 200) {
                var empty = this.fetchEmptyFormResetValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEdit = async (values) => {
        
        const response = await requerimientoService.obtenerPorId(values.id);
        if (response !== undefined) {

            var formValues = this.fetchEditFormValues(response);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idMoneda === SOLES);
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.establecimientos= this.state.establecimientos;
            formValues.centrocosto= this.state.centrocosto;

            const filterSearchEntidad = {
                numeroDocumento: formValues.documentoEntidad,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }
            const responseEntidades = await entidadService.obtenerTodos(filterSearchEntidad);
            const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(formValues.idEntidad);

            formValues.entidades = responseEntidades;
            formValues.direcciones = direccionesEstablecimientos;
            formValues.idCentrocosto = response.requerimiento.idActividad;
            formValues.tipoCambio = response.requerimiento.tipoCambio;

            const products = [];
            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    //id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida
                }
                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

                
            var filterSearchReq = {
                idEstadoRequerimiento: 0,
                filtro: ''
            };
            var requerimientos = await requerimientoService.listarPorEstado(filterSearchReq);
            //debugger
            this.setState({
                visible: true,
                formValues,
                requerimientos: requerimientos ? requerimientos : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: products// []
                }
            });

        }
    }

    handleVer = async (values) => {
        const response = await requerimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);           

            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    //id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida
                }
                formValues.listaComprobanteDetalle.push(oneProd);
            }

            formValues.idCentrocosto = response.requerimiento.idCentrocosto;
            formValues.tipoCambio = response.requerimiento.tipoCambio;
            
            this.setState({
                visibleVer: true,
                formValues,
                //productos: productos ? productos : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: []
                }
            });
        }
    }

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idRequerimiento: values.id,
                codRequerimientoEstado: 'AN'
            };
            var response = await requerimientoService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                //form.setFieldsValue(empty);
                //form.resetFields();

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleExportExcel = async () => {
        var response = await requerimientoService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Requerimientos.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await requerimientoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transporte.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await requerimientoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        
        var file = undefined;
        var response = await requerimientoService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idRequerimiento: item.id
            }
        });
    };

    fetchEditFormValues = (value) => {
        
        return {
            id: value.requerimiento.id,
            //idTipoComprobante: FACTURA.ID,
            idEntidad: value.requerimiento.idEntidad, //..........................................................OK
            documentoEntidad: value.requerimiento.documentoEntidad,
            idEstablecimientoEntidad: value.requerimiento.idEstablecimientoEntidad, //..........................................................OK
            idProyecto: value.requerimiento.idProyecto,
            idEstablecimiento: value.requerimiento.idEstablecimiento, //..........................................................OK
            idCentrocosto: value.requerimiento.idCentroCosto, //..........................................................OK

            //idVendedor: 0, //..........................................................OK
            //idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            //idComprobanteEstado: 0,
            //idEstablecimiento: 0, //..........................................................OK
            //idDetraccion: 0, //..........................................................OK
            //idUsuarioRegistro: 0,
            serie: value.requerimiento.serie, //............................................... OK
            documento: value.requerimiento.documento, //............................................... OK
            fechaStr: value.requerimiento.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.requerimiento.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.requerimiento.diasVencimiento, //..........................................................OK
            tipoCambio: value==undefined ? 0:value.requerimiento.tipoCambio, //..........................................................OK
            observacion: value.requerimiento.observacion, //..........................................................OK
            //flagExportacion: false, //..........................................................OK
            //flagPercepcion: false, //..........................................................OK
            //flagDetraccion: false, //..........................................................OK
            //flagAnticipo: true,
            //flagGrifo: true,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            //sumaSubTotal: 0,
            //sumaIgv: 0,
            //sumaIsc: 0,
            //sumaTotal: 0,
            //porcentajeDetraccion: 0,
            //importeDetraccion: 0,
            //totalDetraccion: 0,
            //porcentajePercepcion: 0,
            //importePercepcion: 0,
            //totalPercepcion: 0,
            //totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            //flagEmpresaGrifo: auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false,
            //almacenLoading: false,
            entidadLoading: false,
            activeKey: "1",
            documentoEntidad: value.requerimiento.documentoEntidad,
            //monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            //establecimientos: [],
            //almacenes: [],
            //vendedores: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            establecimientos: [],
            centrocosto: [],
            documentoEntidad: value.requerimiento.documentoEntidad,
            razonSocialEntidad: value.requerimiento.razonSocialEntidad,
            tipoDocumentoEntidad: value.requerimiento.tipoDocumentoEntidad,
            entidad: value.requerimiento.entidad,
            direccionEntidad: value.requerimiento.direccionEntidad,
            proyectos: [],
            nombreProyecto: value.requerimiento.nombreProyecto,
            idRequerimientoReferencia: 0
        }
    }

    handleChangeRequerimientoModal = (value) => {
        const dataSource = this.state.requerimientos.filter(item => {
            return (item.serie + ' - ' + item.documento)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            importarRequerimientoModal: {
                ...this.state.importarRequerimientoModal,
                dataSource: dataSource
            }
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, requerimientoService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const detracciones = await detraccionService.listar();
        const proyectos = await proyectoService.listar();
        const estado = await requerimientoService.listarEstado();
        const centrocosto = await centroCostoService.listar();

        const filterEntidad = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }

        const entidades = await entidadService.obtenerTodos(filterEntidad);
        var FilterEmpleado=entidades.filter(item => item.idTipoDocumento ==2);
        
        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            vendedores: vendedores ? vendedores : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            //detracciones: detracciones ? detracciones : []
            proyectos: proyectos ? proyectos : [],
            entidades: FilterEmpleado ? FilterEmpleado : [],
            estado: estado ? estado : [],
            centrocosto: centrocosto ? centrocosto : [],
        });
    }



    render() {
        //const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        return (
            <div>
                <Header
                    title="Requerimiento de Producción"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.state.estado}
                    entidades={this.state.entidades}

                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarEntidad={this.handleBuscarEntidad}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarRequerimiento={this.handleImportarRequerimiento}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <BuscarProductoModal
                    visible={this.state.productoVisible}
                    formValues={this.state.productoModal}
                    onChange={this.handleChangeProductoModal}
                    onChangeRow={this.handleChangeSelectedRowKey}
                    onSearch={this.handleBuscarProducto}
                    onCancel={() => this.setState({ productoVisible: false })}
                />
                <ImportarRequerimientoModal
                    visible={this.state.importarRequerimientoVisible}
                    formValues={this.state.importarRequerimientoModal}
                    onChangeRequerimientoModal={this.handleChangeRequerimientoModal}
                    onChangeRow={this.handleSelectedRowRequerimientoPorImportar}
                    onCancel={() => this.setState({ importarRequerimientoVisible: false })}
                />
                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        );
    }
}